import {
  ArrowBigDownDash,
  ArrowBigUp,
  ArrowBigUpDash,
  ArrowDown,
  ArrowRight,
  ArrowRightLeft,
  ArrowUp,
  ArrowUpFromDot,
  ChevronDown,
  ChevronsDown,
  Circle,
  CircleCheck,
  CircleMinus,
  ClockAlert,
  ClockArrowDown,
  ClockArrowUp,
  CloudAlert,
  Eye,
  FileWarning,
  History,
  Hourglass,
  OctagonAlert,
  OctagonX,
  ShieldAlert,
  ShieldBan,
  Siren,
  SquarePlus,
  Timer,
  TimerOff,
  TimerReset,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
} from 'lucide-vue-next'

export const ticketStatusIcon = {
  Circle,
  CircleCheck,
  Timer,
  CircleMinus,
  History,
  Hourglass,
  TimerReset,
  TimerOff,
  ClockArrowUp,
  ClockAlert,
  ClockArrowDown,
} as any

export const ticketStatusColors = {
  IndigoLight: '#C7D2FE',
  Indigo: '#A5B4FC',
  Lime: '#D9F99D',
  Green: '#86EFAC',
  Fuchsia: '#F5D0FE',
  Teal: '#99F6E4',
  Cyan: '#A5F3FC',
  Purple: '#E9D5FF',
  Rose: '#FDA4AF',
  Yellow: '#FEF08A',
  Orange: '#FDBA74',
} as any

export const ticketTypeIcon = {
  SquarePlus,
  ArrowRightLeft,
  TriangleAlert,
  FileWarning,
  TrendingDown,
  TrendingUp,
  OctagonAlert,
  OctagonX,
  Siren,
  CloudAlert,
  Eye,
} as any

export const ticketTypesColors = {
  Blue: '#DBEAFE',
  Green: '#DCFCE7',
  Yellow: '#FEF9C3',
  Orange: '#FFEDD5',
  Bisque: '#FFF7ED',
  Cyan: '#F0FDF4',
  Lavender: '#FAF5FF',
  Lightblue: '#EEF2FF',
  Linen: '#FFF1F2',
  Purple: '#FDF4FF',
  Sky: '#ECFEFF',
  White: '#F3F4F6',
} as any

export const ticketPriorityIcon = {
  ArrowDown,
  ArrowRight,
  ArrowUp,
  ArrowUpFromDot,
  Siren,
  ArrowBigDownDash,
  ChevronDown,
  ChevronsDown,
  ShieldAlert,
  ShieldBan,
  ArrowBigUp,
  ArrowBigUpDash,
} as any

export const ticketPrioritiesColors = {
  IndigoLight: '#EEF2FF',
  Indigo: '#E0E7FF',
  Blue: '#C7D2FE',
  OrangeUpLight: '#FFF7ED',
  OrangeLight: '#FFEDD5',
  Orange: '#FED7AA',
  RedUpLight: '#FEF2F2',
  RedLight: '#FEE2E2',
  Red: '#FECACA',
  GreenUpLight: '#F0FDF4',
  GreenLight: '#DCFCE7',
  Green: '#BBF7D0',
} as any

export const slaIcon = {
  ArrowDown,
  ArrowRight,
  ArrowUp,
  ArrowUpFromDot,
  Siren,
  ArrowBigDownDash,
  ChevronDown,
  ChevronsDown,
  ShieldAlert,
  ShieldBan,
  ArrowBigUp,
  ArrowBigUpDash,
} as any

export const slaColors = {
  IndigoLight: '#EEF2FF',
  Indigo: '#E0E7FF',
  Blue: '#C7D2FE',
  OrangeUpLight: '#FFF7ED',
  OrangeLight: '#FFEDD5',
  Orange: '#FED7AA',
  RedUpLight: '#FEF2F2',
  RedLight: '#FEE2E2',
  Red: '#FECACA',
  GreenUpLight: '#F0FDF4',
  GreenLight: '#DCFCE7',
  Green: '#BBF7D0',
} as any

export const labels = [
  {
    value: 'bug',
    label: 'Bug',
    accessorKey: 'label',
  },
  {
    value: 'feature',
    label: 'Feature',
    accessorKey: 'label',
  },
  {
    value: 'documentation',
    label: 'Documentation',
    accessorKey: 'label',
  },
]

export const sources = [
  {
    value: 'EMAIL',
    label: 'Email',
    icon: 'Mail',
    accessorKey: 'source',
  },
  {
    value: 'Phone',
    label: 'Phone',
    icon: 'Phone',
    accessorKey: 'source',
  },
  {
    value: 'CHAT',
    label: 'Chat',
    icon: 'MessageCircle',
    accessorKey: 'source',
  },
  {
    value: 'PORTAL',
    label: 'Portal',
    icon: 'GalleryThumbnails',
    accessorKey: 'source',
  },
  {
    value: 'API',
    label: 'API',
    icon: 'Webhook',
    accessorKey: 'source',
  },
  {
    value: 'MANUAL',
    label: 'Manual',
    icon: 'NotepadText',
    accessorKey: 'source',
  },
]

export const categories = [
  {
    value: 'Email Issues',
    label: 'Email Issues',
    accessorKey: 'category',
  },
  {
    value: 'Network/Internet Access',
    label: 'Network Internet',
    accessorKey: 'category',
  },
  {
    value: 'File Access/Permissions',
    label: 'File Access',
    accessorKey: 'category',
  },
]

export const ranges = [
  {
    value: 'today',
    label: 'Today',
    accessorKey: 'dateRange',
  },
  {
    value: 'last_7_days',
    label: 'Last 7 Days',
    accessorKey: 'dateRange',
  },
  {
    value: 'last_month',
    label: 'Last Month',
    accessorKey: 'dateRange',
  },
  {
    value: 'last_year',
    label: 'Last Year',
    accessorKey: 'dateRange',
  },
]
export const clients = [
  {
    value: [],
    label: 'Client',
    icon: null,
    accessorKey: 'companyId',
  },
  {
    value: 'my_companies',
    label: 'My linked Companies',
    icon: null,
    accessorKey: 'companyId',
  },
  {
    value: 'companies_managed',
    label: 'Companies Managed',
    icon: null,
    accessorKey: 'companyId',
  },
]
export const assignees = [
  {
    value: 'me',
    label: 'Assign to me',
    icon: null,
    accessorKey: 'assignedToId',
  },
  {
    value: [],
    label: 'Asignee',
    icon: null,
    accessorKey: 'assignedToId',
  },
]
export const teams = [
  {
    value: 'my_team',
    label: 'My Team',
    icon: null,
    accessorKey: 'assignedToTeamId',
  },
  {
    value: [],
    label: 'Team',
    icon: null,
    accessorKey: 'assignedToTeamId',
  },
]
export const contacts = [
  {
    value: [],
    label: 'Contact',
    icon: null,
    accessorKey: 'customerId',
  },
]

export const roles = [
  {
    id: 'client',
    name: 'Client',
  },
  {
    name: 'Client Manager',
    id: 'client_manager',
  },
  {
    name: 'Client Approver',
    id: 'client_approver',
  },
]
